import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CoreTranslateService, UtilitysService } from 'src/app/services/utilitys/utilitys.service';
import { ModalService } from '../modal.service';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/services/api/api.service';
import { NavigateService } from 'src/app/services/navigate/navigate.service';
import { SweetalertService } from 'src/app/services/sweetalert/sweetalert.service';

@Component({
  selector: 'app-servey-submit-confirm',
  templateUrl: './servey-submit-confirm.component.html',
  styleUrls: ['./servey-submit-confirm.component.scss']
})
export class ServeySubmitConfirmComponent implements OnInit {
  @ViewChild('serveySubmitConfirmModel', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  isShow = false;
  answers: any ;
  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
    private utility: UtilitysService,
    private api: ApiService,
    private ngxLoading: NgxUiLoaderService,
    private navigate: NavigateService,
    private router: Router,
    private swAlert: SweetalertService,
    private coreTranslate: CoreTranslateService
  ) { }

  ngOnInit() {
 
    this.modalServ.onServeySubmit.subscribe(req => {
      console.log(req.answers);
      this.answers = req.answers;
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onServeySubmitHide.subscribe(req => {
      this.hide();
    });
  }
  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
  }
  confirm() {
    this.ngxLoading.start();
    this.api.sureyAnswer(this.answers).subscribe(res => {
      // console.log('2222222222222222222222222222222222222222222222222');
      console.log(res);
      if (res.Code == 200) {
        this.hide();
        this.navigate.navigateMenu('survey-success');
      } else {
        this.swAlert.error(this.coreTranslate.getWord('GENERAL.AN_ERROR_OCCURRED'), res.Message ); 
      }
      this.ngxLoading.stopAll();
    }, err => {
      this.swAlert.error(this.coreTranslate.getWord('GENERAL.AN_ERROR_OCCURRED'), err.error.ExceptionMessage);
      console.error(err);
      this.ngxLoading.stopAll();
    });
  }

}
